import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { dateUtilities, RequirePermissions, ssgFormsAdapters, errorUtilities, numberUtils } from '../common';
import * as programEnrollmentUtils from '../common/program-enrollment-utilities';
import * as touchpointActions from './touchpoints.actions';
import * as programActions from '../programs/program.actions';
import * as programUtilities from '../common/program-utilities';
import { Title } from '../layout';
import queryString from 'query-string';
import { adapters } from '@social-solutions/ssg-forms-processing';
import { LoadingPane, SsgFormComponent, ConfirmModalWindow, ssgFormActions } from '@social-solutions/ssg-forms';
import { toastr } from 'react-redux-toastr';

const ssgFormId = "edit-form-response";

export class EditTouchpointResponseComponent extends Component {
  constructor() {
    super();
    this.state = {
      localState: null, // hold the state needed to call save
      localModal: null  // hold a reference to the confirmation modal
    }
  }

  componentWillMount() {
    const { ssgFormActions } = this.props;

    ssgFormActions.hardReset(ssgFormId);
  }

  componentDidMount() {
    const { touchpointActions, match, programActions } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId, responseId } = params;

    programActions.fetchAllPrograms();
    touchpointActions.fetchTouchpointForm(siteId, programId, touchpointFormId, false, responseId);
    touchpointActions.fetchTouchpointResponse(siteId, programId, touchpointFormId, responseId);
  }

  handleSaveClicked(state) {
    const { localModal } = this.state;
    this.setState({localState : state});
    localModal && localModal.show();
  }

  handleConfirmPopupWindowChoice(choice, state) {
    if (choice) {
      this.handleSave(state);
    }
    else {
      this.setState({localState : null});
    }
  }

  handleSave(state) {
    const { touchpointActions, match, redirectTo } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId, responseId } = params;
    const { updateTouchpointForm } = touchpointActions;

    updateTouchpointForm(siteId, programId, touchpointFormId, state.value, responseId)
      .then(val => {
        toastr.success('Success', 'Form response saved!');
        redirectTo('/responses');
      })
      .catch(err => {
        if (!err.validationResult || err.validationResult.isValid)
          toastr.error(err.errorCode, err.errorMessage);
        else {
          touchpointActions.updateShowValidation(ssgFormId, true);
          window.scrollTo(0, 0);
        }
      });
  }

  handleAttachmentDownload(formId, elementId, fileId) {
    const { touchpointActions, match } = this.props;
    const { params } = match;
    const { siteId, programId, responseId } = params;

    var guidElementId = numberUtils.convertIntToGuid(Number(elementId));

    return touchpointActions.fetchAttachment(siteId, programId, formId, responseId, guidElementId, fileId)
      .catch(error => {
        toastr.error("Failure", "Failed to download the attachment.");
      });
  }

  render() {
    const { touchpoints, match, redirectTo, routing, programEnrollment, programs } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId, responseId } = params;

    const touchpointFormState = ssgFormsAdapters.convertLoadingState(touchpoints.touchpointForms.get(touchpointFormId));
    const form = !!touchpointFormState && touchpointFormState.data;
    const fieldFormatSetting = !!form && form.fieldFormatSetting;
    const allProgs = programUtilities.getAllPrograms(programs);
    const progsFromResponse = programUtilities.getProgramsFromTouchpointResponse(touchpoints, responseId);

    const submissionState = touchpoints.formSubmission.get(touchpointFormId);
    const isSubmitting = !!submissionState && submissionState.isFetching;
    const serverErrors = errorUtilities.getServerErrors(form, submissionState && submissionState.err);

    const { location } = routing || {};
    const { search } = location || {};
    const query = queryString.parse(search);
    const redirectUrl = query.redirectUrl;

    const touchpointResponseState = ssgFormsAdapters.convertLoadingState(touchpoints.touchpointResponses.get(responseId));
    const { data : existingResponse } = touchpointResponseState || {};
    var dateTaken = existingResponse && existingResponse.responseCreatedDate;

    const formName = programEnrollmentUtils.getFormAlias(programEnrollment, siteId, programId, touchpointFormId);
    const touchpointAnswers = form && existingResponse && adapters.convertJsonResponse(form, existingResponse);

    let finalFormat;
    if (fieldFormatSetting !== 'US') {
      const friendlyFormat = !!dateTaken && dateUtilities.getUserFriendlyFormatFromJson(dateTaken);
      const dateArray = !!friendlyFormat && friendlyFormat.split('/');
      finalFormat = fieldFormatSetting === 'CA' ? `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`: `${dateArray[1]}/${dateArray[0]}/${dateArray[2]}`;
    } else {
      finalFormat = dateTaken;
    }

    const dateDisplay = finalFormat ? (
      <span>
        Taken {finalFormat}
      </span>) : null;

    const formProps = {
      id: ssgFormId,
      form: {
        ...form,
        name: formName
      },
      initialValues: touchpointAnswers,
      customValidationErrors: serverErrors,
      subTitleDisplay: dateDisplay,
      onCancel: (state) => redirectTo(redirectUrl ? redirectUrl : '/'),
      onSave: (state) => this.handleSaveClicked(state),
      saving: isSubmitting,
      onDownloadAttachment: (formId, elementId, fileId) => this.handleAttachmentDownload(formId, elementId, fileId),
      showRequiredKey: true,
      allPrograms: allProgs,
      initialSelectedPrograms: progsFromResponse,
      css: {
        form: "ssg-form form-display",
        formBody: 'ssg-forms-body',
        actions: "ssg-forms-actions form-actions-display",
      },
      country: fieldFormatSetting !== false ? fieldFormatSetting : undefined
    };

    return (
      <RequirePermissions
        siteId={siteId}
        programId={programId}
        formId={touchpointFormId}
        requireEdit={true}>
        <Title title="Edit Form Response"/>
        <LoadingPane id="fetchLoadingPane" loadingState={[touchpointFormState, touchpointResponseState]}>

            <ConfirmModalWindow id="edit-form-confirm"
              title={"Save Form Response"}
              modalRef={(modal) => this.setState( {localModal : modal})}
              onClose={(e, confirmed) => this.handleConfirmPopupWindowChoice(confirmed, this.state.localState)}>
              <p>{`Are you ready to submit this response to ${formName}?`}</p>
            </ConfirmModalWindow>
            <SsgFormComponent {...formProps} />
        </LoadingPane>
      </RequirePermissions>
    );
  }
}

EditTouchpointResponseComponent.propTypes = {
  touchpointActions: PropTypes.object.isRequired,
  touchpoints: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      siteId: PropTypes.isRequired,
      programId: PropTypes.isRequired,
      touchpointFormId: PropTypes.isRequired
    })
  })
};

const mapStateToProps = ({ routing, touchpoints, programEnrollment, programs }) => {
  return {
    routing,
    touchpoints,
    programEnrollment,
    programs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    touchpointActions: bindActionCreators(touchpointActions, dispatch),
    ssgFormActions: bindActionCreators(ssgFormActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
    programActions: bindActionCreators(programActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTouchpointResponseComponent);



// WEBPACK FOOTER //
// src/touchpoints/edit-touchpoint-response.component.js